import TestCasesTab from './test-cases-tab'

export default TestCasesTab
